module.exports = __webpack_public_path__ + "img/introduce-two.1cb29610.png";